module.exports = __webpack_public_path__ + "img/slider_arrow_right.d6941cf4.svg";